<template>
  <van-popup v-model="dialogIsVisible" class="pop-tips" closeable>
    <div class="pop-cont">
      <img src="@assets/img/popbg.png" />
      <p>你离心仪的职位只差一份简历</p>
      <router-link :to="{ name: 'basicInfo' }">
        <van-button
          type="primary"
          color="linear-gradient(to right top, #F69B58,#F87342)"
          round
          >创建简历</van-button
        >
      </router-link>
    </div>
  </van-popup>
</template>

<script>
export default {
  // 组件的名称
  name: "createResumeDialog",

  // 数据绑定
  data() {
    return {
      dialogIsVisible: false
    };
  },
  methods: {
    isShowDia() {
      let self = this
      self.dialogIsVisible = true
    }
    // 关闭弹窗
  }
}
</script>
